import React from 'react';
import { forwardRef, PropsWithChildren } from 'react';

import {
  CmBox,
  CmFormControl,
  CmFormLabel,
  CmInput,
  CmInputGroup,
  CmInputRightElement,
} from '@/components/uiParts';
import { ViewIcon, ViewOffIcon } from '@/components/uiParts';

interface Props {
  isRequired?: boolean;
  fontWeight?: 'bold' | 'normal';
  isShow: boolean;
  isInvalid?: boolean;
  label: string;
  id?: string;
  handleShowPassword: (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => void;
  onBlur?: () => void;
}

export const CmLabelAndPasswordInput = forwardRef<
  HTMLInputElement,
  PropsWithChildren<Props>
>(
  (
    {
      isRequired = false,
      fontWeight,
      isShow = false,
      isInvalid = false,
      id = '',
      label,
      handleShowPassword,
      children,
      ...rest
    },
    ref
  ) => {
    return (
      <CmFormControl {...{ isInvalid }}>
        <CmFormLabel htmlFor={id} {...{ isRequired, fontWeight }}>
          {label}
        </CmFormLabel>
        <CmInputGroup>
          <CmInput
            ref={ref}
            {...{ ...rest, id, isRequired, isPassword: !isShow }}
          />
          <CmInputRightElement>
            <CmBox onClick={handleShowPassword}>
              {isShow ? (
                <ViewOffIcon cursor="pointer" />
              ) : (
                <ViewIcon cursor="pointer" />
              )}
            </CmBox>
          </CmInputRightElement>
        </CmInputGroup>
        {children}
      </CmFormControl>
    );
  }
);

CmLabelAndPasswordInput.displayName = 'CmLabelAndPasswordInput';
